import { render, staticRenderFns } from "./AnimalNumbers.vue?vue&type=template&id=8e29af72&"
import script from "./AnimalNumbers.vue?vue&type=script&lang=js&"
export * from "./AnimalNumbers.vue?vue&type=script&lang=js&"
import style0 from "./AnimalNumbers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports